import { Link } from "react-router";
import { Button, EmptyState, Notice, Seitenzustand, StatusBadge } from "../ui";
import { Card, Grid, KpiTile, PageHeader, Split } from "../ui/Layout";
import { useLaden, useUebersicht } from "./api";
import { useFreieRegale } from "./regale-api";
import { useBuchungen } from "./buchungen-api";
import { formatDatum, formatTag } from "@shared/zeit";

export function Uebersicht() {
  const laden = useLaden();
  const uebersicht = useUebersicht();
  const frei = useFreieRegale();
  const offen = useBuchungen("reserviert");
  const einrichtungOffen = laden.data && !laden.data.einstellungen.einrichtung.abgeschlossenAt;
  return (
    <>
      <PageHeader
        title="Übersicht"
        sub={formatDatum(new Date())}
        actions={
          <>
            {laden.data?.sumupVerbunden ? <StatusBadge status="paid">SumUp verbunden</StatusBadge> : <StatusBadge status="neutral">SumUp noch nicht verbunden</StatusBadge>}
            <Link to="/laden/buchungen/neu" className="rg-btn rg-btn--primary">Buchung anlegen</Link>
          </>
        }
      />
      <Seitenzustand query={uebersicht}>
        {(d) => (
          <>
            {einrichtungOffen ? (
              <Notice tone="info" title={d.regale === 0 ? "Der Laden ist noch leer" : "Einrichtung noch nicht abgeschlossen"} action={<Link to="/laden/einrichtung" className="rg-btn rg-btn--primary">Einrichtung öffnen</Link>}>
                Laden, Preise, Regale, SumUp und Personal in sechs Schritten – jederzeit unterbrechbar.
              </Notice>
            ) : null}
            {offen.data?.buchungen.length ? (
              <Notice tone="attention" title={`${offen.data.buchungen.length} ${offen.data.buchungen.length === 1 ? "Vertrag wartet" : "Verträge warten"} auf Zustimmung`} action={<Link to={`/laden/buchungen/${offen.data.buchungen[0]!.id}`} className="rg-btn rg-btn--secondary">Ansehen</Link>}>
                {offen.data.buchungen.slice(0, 3).map((b) => `${b.mieterName} · Regal ${b.regalNummer} ab ${formatTag(b.start)}`).join(" · ")}
              </Notice>
            ) : null}
            <Grid>
              <KpiTile label="Regale" value={d.regale} note={frei.data ? `${frei.data.belegt} belegt · ${frei.data.frei.length} frei` : undefined} />
              <KpiTile label="Aktive Mieter" value={d.mieter} />
              <KpiTile label="Artikel im Regal" value={d.artikelImRegal} />
            </Grid>
            <Split
              main={
                <Card title="Letzte Verkäufe" actions={<Link to="/laden/verkaeufe">Alle Verkäufe</Link>}>
                  <EmptyState compact illustration="empty-shelf" title="Verkäufe des Tages">
                    Die Tagesliste mit allen Warenkörben und Zahlungen steht unter Verkäufe und Abgleich.
                  </EmptyState>
                  <Link to="/laden/verkaeufe" className="rg-btn rg-btn--secondary">Verkäufe und Abgleich öffnen</Link>
                </Card>
              }
              aside={
                <Card title="Belegung" actions={<Link to="/laden/belegung">Kalender</Link>}>
                  {frei.data ? (
                    <div className="sc-col">
                      <span><span className="sc-strong">{frei.data.belegt} / {frei.data.gesamt}</span> Regale belegt</span>
                      {frei.data.frei.length ? <div className="sc-toolbar"><span className="sc-muted sc-small">Frei ab sofort</span>{frei.data.frei.slice(0, 8).map((r) => <Link key={r.id} to={`/laden/regale/${r.id}`} className="sc-pill" style={{ height: 32 }}>{r.nummer}</Link>)}</div> : <span className="sc-muted sc-small">Kein Regal frei.</span>}
                      {frei.data.baldFrei.length ? <div className="sc-toolbar"><span className="sc-muted sc-small">Bald frei</span>{frei.data.baldFrei.map((r) => <StatusBadge key={r.id} status="attention">{r.nummer} ab {r.aktuell?.ende ? formatTag(r.aktuell.ende) : "–"}</StatusBadge>)}</div> : null}
                    </div>
                  ) : <Button variant="quiet" disabled>Lädt …</Button>}
                </Card>
              }
            />
          </>
        )}
      </Seitenzustand>
    </>
  );
}
